import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=dd6834e0&scoped=true&"
import script from "./MemberAddress.vue?vue&type=script&lang=js&"
export * from "./MemberAddress.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddress.vue?vue&type=style&index=0&id=dd6834e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6834e0",
  null
  
)

component.options.__file = "MemberAddress.vue"
export default component.exports